<template>
  <div class="wrapper">
    <!-- 头图 -->
    <header>
      <img :src="ui.head" alt="头图" class="header_img"/>
    </header>
    <div :style="`backgroundColor:${ui.bg_color}`" ref="main" class="main_wrapper">
      <!-- 倒计时 -->
      <countDown v-if="ui.is_counter" :labelColor="ui.font_color"
                 :stime="stime"></countDown>
      <div class="form_wrapper" ref="form_wrapper" style="margin-top: 0">
        <!-- 版表单部分-->
        <div class="top_form_bg">
          <img src="../../assets/image/guangzhou/form_bg.jpg" alt="" class="top_bg">
          <div class="main_form_wrap">
            <div style="position: relative;top: 0;left: 0;width: 100%;height: 100%;">
              <img  :src="tabs_bg[current_tab]" alt="" style="width: 100%;" class="tabs_bg">
              <div style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;">
                <div class="new_tabs_wrap">
                  <!--              :style="{ backgroundImage: `url(${tabs_bg[current_tab]})` }"-->
                  <div class="real_tabs">
                    <div v-for="(item,index) in tabs_list" class="real_tab_item" @click="change_tabs(index)"
                         :class="current_tab == index ? 'active_real_tab_item' : 'real_tab_item'">
                      <p class="size_20">{{item.name}}</p>
                      <p class="size_16">{{item.desc}}</p>
                    </div>
                  </div>
                </div>
                <!-- 表单部分 -->
                <div class="real_new_form">
                  <van-field
                      v-if="is_city"
                      readonly
                      v-model="action_form.city"
                      name="城市"
                      placeholder="请选择城市"
                      @click="city_show = true"
                  >
                    <template slot="left-icon">
                      <img src="../../assets/image/guangzhou/address.png" alt="" class="left_icon">
                    </template>
                    <template slot="right-icon">
                      <van-icon name="play"  style="transform: rotate(90deg)" color="#a0a4ac"/>
                    </template>
                    
                  </van-field>
                  <van-field
                      v-model="action_form.name"
                      name="姓名"
                      placeholder="请输入姓名"
                  >
                    <template slot="left-icon">
                      <img src="../../assets/image/guangzhou/user.png" alt="" class="left_icon">
                    </template>
                  </van-field>
                  <van-field
                      type="tel"
                      v-model="action_form.phone"
                      name="电话"
                      placeholder="请输入电话"
                  >
                    <template slot="left-icon">
                      <img src="../../assets/image/guangzhou/phone.png" alt="" class="left_icon">
                    </template>
                  </van-field>
                  <van-field
                      v-model="action_form.company_name"
                      name="公司名称"
                      placeholder="公司名称(非公司类填写个人)"
                  >
                    <template slot="left-icon">
                      <img src="../../assets/image/guangzhou/company.png" alt="" class="left_icon">
                    </template>
                  </van-field>
                  <!--  协议-->
                  <div class="policy_wrapper">
                    <policy></policy>
                  </div>
                  <!-- 按钮-->
                  <template>
                    <div
                        class="form_item_btn able_btn"
                        round  @click="submitForm"
                        :style="`backgroundColor: ${ui.btn_bg_color};color: ${ui.btn_font_color}`">
                      {{ui.btn_text}}
                    </div>
<!--                    <van-button class="form_item_btn"-->
<!--                                type="info" round v-if="is_stop" :disabled="true">活动已结束-->
<!--                    </van-button>-->
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 走马灯-->
      <banner v-if="ui.is_banner"></banner>
    </div>
    <div class="detail_img" :class="ui.is_copyright ? '' : 'pb_20'">
      <!-- 详情图-->
      <img :src="ui.tail" alt="详情图" class="detail_img" ref="tailImage"/>
    </div>
    <!-- 版权-->
    <copyright v-if="ui.is_copyright"></copyright>
    <div class="bottom_btn"
         v-if="btn_show"
         @click="btn_click_form"
         :style="`backgroundColor: ${ui.btn_bg_color};color: ${ui.btn_font_color}`">
      {{ui.btn_text}}
    </div>
<!--    <div class="footer_wrapper">-->
<!--     -->
<!--    </div>-->

    <!-- 报名成功弹框-->
    <el-dialog :visible.sync="is_success" v-if="is_success" class="Successful" width="50%">
      <el-result icon="success" title="报名成功"></el-result>
    </el-dialog>

    <!-- 城市弹框-->
    <!--:style="{height: '50%'}" :lock-scroll="false"-->
    <van-popup v-model="city_show" round position="bottom" :safe-area-inset-bottom="true">
      <!--  style="height: 100%;overflow-x: hidden;overflow-y: auto"-->
      <!-- style="height: 60vh;display: flex;flex-direction: column;overflow: hidden"-->
      <div>
        <div style="display: flex;margin: 20px;box-sizing: border-box;justify-content: space-around;gap: 20px">
          <p v-for="(item,index) in city_type_list" @click="change_area_type(item)" class="city_p"
             :class="current_city_type == item ? 'active_city_type' : ''">
            {{item}}
          </p>
        </div>
        <template v-if="current_city_type == '国内'">
          <van-cascader
              v-model="cascaderValue"
              title="请选择所在地区"
              :options="citys"
              :fieldNames="cityNames"
              @close="city_show = false"
              @finish="finishCity"
              class="city_cascader"
              style="flex: 1;height: 100%;overflow-y: scroll"
          />
        </template>
        <template v-if="current_city_type == '国外'">
          <van-cascader
              v-model="cascaderValue"
              title="请选择所在地区"
              :options="city_list"
              :fieldNames="extarecityNames"
              @close="city_show = false"
              @finish="finishCity"
              class="city_cascader"
              style="flex: 1;height: 100%;overflow-y: scroll"
          >

          </van-cascader>

          <!--         <div style="overflow-y: auto;flex: 1;position: relative;height: 100%;">-->
          <!--           <template>-->
          <!--             <div class="left_country" style="padding: 0 10px;flex: 1;">-->
          <!--               <div v-for="(area,area_index) in  city_list" :key="area_index" class="city_cur_p">-->
          <!--                 <h4 style="line-height: 30px;font-size: 18px;padding-left: 10px">{{area.area}}</h4>-->
          <!--                 <li v-for="(city,city_index) in  city_list[area_index].child" @click="change_city(city)"-->
          <!--                     :class="current_city == city ? 'active_cur_p' : ''" class="city_cur">-->
          <!--                   {{city}}-->
          <!--                 </li>-->
          <!--               </div>-->

          <!--             </div>-->
          <!--           </template>-->
          <!--         </div>-->
        </template>
      </div>

    </van-popup>

  </div>
</template>

<script>
  import countDown from "@/components/countDown";
  import policy from "@/components/policy";
  import copyright from "@/components/copyright";
  import banner from "@/components/banner";
  import _geturl from "@/utils/_geturl";
  import lib_activity from "@/libs/lib_activity";
  import lib_city from "@/libs/lib_city";
  import _wx from "@/common/_wx";
  import _time from "@/utils/_time";
  import _object from "@/utils/_object";
  import _regular from "@/utils/_regular";
  import lib_clue from "@/libs/lib_clue";
  import lib_success from "@/libs/lib_success";
  import cache_url from "@/cache/cache_url";
  import Toast from "vant/lib/toast";
  import _monitor from "@/monitor/_monitor";
  import city from "@/js/city";
  import { Message } from "element-ui";

  let action_form = {
    name: '', //姓名
    phone: '', //电话
    city: '', //城市
    company_name: '', //公司名称
    expo_type: '预定展位', //参展类别
    city_type: '国内'
  }

  export default {
    name: "guangzhou",
    components: {
      countDown,
      policy,
      copyright,
      banner,
    },
    data() {
      return {
        title: '', // document的title
        activity_id: 0, //活动ID
        tids: "", //模板ID
        channel: '', //渠道
        channel_name: '', //渠道名
        tid: 0, // 有无车型库
        share_theme: '', //分享描述
        stime: 0, // 项目开始时间
        etime: 0, // 项目结束时间
        ui: {
          head: '', //头图
          tail: '', //详情图
          share: '', //分享图
          bg_color: '', //表单背景色
          font_color: '', //文本颜色
          btn_bg_color: '', //按钮背景色
          btn_font_color: '', //按钮文本颜色
          btn_text: '', //按钮文本值
          btm_btn_text: '', //底部按钮文本
          is_banner: 0, //是否有轮播图
          is_counter: 0, //是否有倒计时
          is_copyright: 1, //协议
          jmp_url: 0, //0-报名成功;1-帮朋友报名;2-置换二手车;3-邮寄门票
        },

        action_form: action_form,
        //城市联级选择
        citys: [], //城市数据
        cascaderProps: { //配置项
          expandTrigger: 'hover', //展开方式
          value: "id", //指定选项的值
          label: "name", //指定选项标签
          children: "children", //指定选项的子选项
          emitPath: false, //该节点数组
        },

        is_success: false, //报名成功弹框
        is_city: false, //表单城市项，默认无城市
        is_stop: false, //活动是否已结束
        is_display: true, //底部按钮
        btn_show: false, //底部按钮显隐
        series_name: "请选择意向车型",


        // vant相关
        city_show: false,
        cascaderValue: '', //
        cityNames: {
          text: 'name',
          value: 'id',
          children: 'children',
        },
        city_type_list: ['国内', '国外'],
        current_city_type: '国内',

        current_city: '',
        city_list: city,

        extareCascaderValue: '',
        extarecityNames: {
          text: 'name',
          value: 'id',
          children: 'children',
        },

        tabs_list: [
          {name: '预定展位', desc: '(展位在线预定)'},
          {name: '专业观众观展', desc: '(预约参观登记)'}
        ],
        current_tab: 0,
        tabs_bg: [ require('../../assets/image/guangzhou/tab_02.png'),require('../../assets/image/guangzhou/tab_01.png')]

      }
    },
    created() {
      // 地址栏
      this.activity_id = _geturl("activity_id");
      this.tids = _geturl("tids");
      this.channel = _geturl("channel");
      this.channel_name = _geturl("channel_name");

      //获取项目信息
      lib_activity.info(this.activity_id, this.tids, this.init_info);

      //监测
      _monitor.init(this.channel, this.activity_id);

    },
    mounted() {
      // 监听页面滚动
      window.addEventListener('scroll', this.handleScroll, true)
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll, true)
    },
    destroyed() {
      // window.removeEventListener('scroll', this.handleScroll())
    },
    methods: {
      //初始化项目信息
      init_info(data) {
        console.log(data)
        this.title = data.activity.theme;
        document.title = this.title;
        this.share_theme = data.activity.share_theme;
        this.etime = data.activity.etime;
        this.stime = data.activity.stime;
        this.tid = data.activity.tid;
        if (data.ui == null) {
          this.ui = {};
          return;
        }
        this.ui = data.ui;
        // console.log(data.activity.city, '城市')
        // 项目结束
        // if (!data.activity.state || (_time._current() > data.activity.etime)) {
        //   this.is_stop = true;
        //   return;
        // }
        // 判断是否有城市
        let city = []
        if (data.activity.city) {
          city = data.activity.city.split(',');
        }
        console.log(city, '城市')
        if (city.length == 1 && city[0] > 0) {
          //单城市项目
          this.is_city = false;
        } else {
          //多城市项目
          this.is_city = true;
          this.getCity(data.activity.city)
        }
        // 分享： ui存在再分享
        if (_object._length(this.ui) > 0) {
          this.share();
        }
      },

      // 分享
      share() {
        let that = this;
        lib_activity.share(function (data) {
          let options = {};
          options.title = that.title;
          options.desc = that.share_theme;
          options.link = window.location.href;
          options.image = that.ui.share;

          _wx.js_api(data, _wx.share, options);
        })
      },
      // 加载城市
      getCity(city) {
        let that = this;
        lib_city.list(city, function (data) {
          that.citys = data;
          console.log(data, '城市')
        })
      },


      //tabs切换
      change_tabs(index) {
        this.current_tab = index
      },
      // 国内/国外
      change_area_type(item) {
        this.current_city_type = item
      },
      //左右侧城市选择

      change_city(city) {
        this.current_city = city
        this.action_form.city = city
        this.city_show = false
        console.log(city, '地区')
      },

      getChineseBracketContent(str) {
        const first = str.indexOf('（');
        const last = str.lastIndexOf('）');
        if (first !== -1 && last !== -1 && last > first) {
          return str.substring(first + 1, last);
        }
        return '';
      },


      submitForm() {
        if (this.is_city && !this.action_form.city) {
          Toast('请选择城市');
          return;
        }
        // if (!this.action_form.expo_type) {
        //   Toast('请选择参展类别');
        //   return;
        // }
        if (!this.action_form.name) {
          Toast('请输入您的姓名');
          return;
        }
        if (this.action_form.name && this.action_form.name.length > 20) {
          Toast('请输入正确的姓名');
          return;
        }
        if (!this.action_form.phone) {
          Toast('请输入您的手机号');
          return;
        }
        if (!_regular.is_mobile(this.action_form.phone)) {
          Toast('请输入正确的手机号');
          return;
        }
        if (!this.action_form.company_name) {
          Toast('请输入您的公司名称');
          return;
        }

        if (this.action_form.company_name && this.action_form.company_name.length > 50) {
          Toast('请输入正确的公司名称');
          return;
        }

        let form_extra = {
          '参展类别': this.tabs_list[this.current_tab].name,
          '公司名称': this.action_form.company_name,
        }
        let cityArr = this.action_form.city.split('/'); // vant形式
        let location
        if (this.current_city_type == '国内') {
          location = this.is_city ? (cityArr[0] + '+' + cityArr[1]) : '';

        } else if (this.current_city_type == '国外') {
          let str = this.is_city ? (cityArr[1]) : '';
          location = this.getChineseBracketContent(str)
        }
        let url = window.location.href;
        let form_ui_id = this.ui.hasOwnProperty("id") ? this.ui.id : 0;
        let params = {
          activity_id: this.activity_id,
          channel_code: this.channel,
          channel_name: this.channel_name,
          location,
          url,
          form_name: this.action_form.name,
          form_phone: this.action_form.phone,
          form_extra: JSON.stringify(form_extra),
          form_ui_id,
        };
        let that = this;
        // console.log(params, '入参')
        lib_clue.receive(params, function (data) {
          // Message.success('报名成功')
          //监测上报
          _monitor.submit()

          //缓存当页面链接
          cache_url.set(window.location.href)
          //跳转
          // setTimeout(() => {
          // }, 2000);
          //不同参数跳转不同页面
          const jmp_url = _object._length(that.ui) > 0 ? that.ui.jmp_url : 0
          //跳转地址
          const url = lib_success.jmp_url(jmp_url)
          that.$router.push({
            path: url,
            query: {
              id: data.id
            },
          })
        })
      },

      // 滚到表单开始部分
      btn_click_form() {
        let form_top = this.$refs.main.offsetTop - 50;
        document.documentElement.scrollTop = form_top
        document.body.scrollTop = form_top;
        document.querySelector('#app').scrollTop = form_top
      },
      // 滚动
      handleScroll() {
        let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || document.querySelector('#app').scrollTop;
        this.$nextTick(() => {
          if (scrollHeight >= this.$refs.tailImage.offsetTop) {
            this.btn_show = true;
          } else {
            this.btn_show = false;
          }
        })
      },

      // vant相关
      finishCity({selectedOptions}) {
        console.log(selectedOptions, '自定义1212')
        this.city_show = false;
        this.action_form.city = selectedOptions.map((option) => option.name).join('/');
      },

    },
  };
</script>

<style lang="less" scoped>
  @import "../../assets/style/autoshow/base.less";
  @import "../../assets/style/autoshow/form.less";
  // form部分
  @import "../../assets/style/common/successful.less"; //报名成功
  .city_cascader {
    height: 100%;
    overflow-y: auto;
    flex: 1;
    /*/deep/ .van-tabs .van-tabs--line .van-cascader__tabs {*/
    /*   overflow-y: auto;*/
    /* }*/
  }

  .city_p {
    font-size: 32px;
    width: fit-content;
  }

  .active_city_type {
    padding: 2px 10px;
    border-bottom: solid 6px #ee0a24;
    box-sizing: border-box;
    border-radius: 6px;
  }

  .city_cur_p {
    padding: 10px 0;
    color: #333333;
    font-size: 14px;
  }

  .city_cur {
    padding: 8px 0;
  }

  .active_cur_p {
    color: #ee0a24;
  }

</style>
<style lang="less">

  .custom_radio .van-radio__label span {
    font-size: 30px !important;
  }

  .custom_radio .van-radio__icon {
    font-size: 30px !important;
    display: flex;
    align-items: center;
  }
</style>

<style lang="less" scoped>
  .form_wrapper {
    width: 100%;
    margin-left: 0;
    position: relative;
    top: -6px;
    /*transform: translateY(-6px);*/
  }
  .top_form_bg{
      width: 100%;
      position: relative;
      height: 918px;
      .top_bg{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
      }
      /*height: 1600px;*/
      /*background-image: url("../../assets/image/guangzhou/form_bg.jpg");*/
      /*background-repeat: no-repeat;*/
      /*background-size: 100% 100%;*/
  }
  .main_form_wrap{
    position: absolute;
    top: 140px;
    left: 0;
    width: calc(100% - 24px);
    margin-left: 12px;
    height: 768px;
    border: solid 2px #d6dae7;
    border-radius: 10px;
    /*background-image: url("../../assets/image/guangzhou/tab_01.png");*/
    /*background-repeat: no-repeat;*/
    /*background-size: contain;*/
  }
  .new_tabs_wrap {
    width: 100%;
    height: 124px;
    /*margin-left: 12px;*/
    position: relative;
    /*transform: translateY(-170px);*/
    // background: url("../../assets/image/guangzhou/tab_01.png") no-repeat;
    img{
      position: absolute;
      top: 0;
    }
  }


  .real_tabs {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;

    .real_tab_item {
      display: flex;
      width: 50%;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding-bottom: 20px;
      box-sizing: border-box;
      user-select: none;
      p {

        color: #516185;
      }

      .size_20 {
        font-size: 40px;
        letter-spacing: 4px;
        font-weight: bold;
      }

      .size_16 {
        font-size: 20px;
        letter-spacing: 1px;
      }

    }

    .active_real_tab_item {
      p {
        color: #3165cf;
      }
    }
  }

  .real_new_form {
    width: 99%;
    padding: 20px 40px 0px 40px;
    box-sizing: border-box;
  }
  .left_icon{
    height: 36px;
  }
  /deep/ .van-cell{
    line-height: 64px;
    display: flex;
    align-items: center;
    border-radius: 10px;
    padding-left: 10px;
    margin-bottom: 34px;
    border: solid 2px #f1f1f2;
    box-sizing: border-box;
    width: 100%;

  }
  /deep/ .van-field__control::placeholder{
    color: #a0a4ac;
  }
  /deep/ .van-cell::after{
    border-bottom-color: transparent;
  }
  /deep/ .van-field__left-icon{
    padding-left: 8px;
    display: flex;
  }
  /deep/ .van-field__right-icon{
    padding-right: 18px;
  }
  .form_item_btn{
    border-radius: 10px;
    animation: none;
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    margin-top: 20px;
  }
  .bottom_btn{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  .main_wrapper{
    padding-top: 0;
  }
</style>
